// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstShiftTeam {
constructor({
        id = null,
        mstShiftId = '',
        name = '',
        code = '',
        admDeptId = '',
        emAclDeptName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstShiftId = mstShiftId;
    this.name = name;
    this.code = code;
    this.admDeptId = admDeptId;
    this.emAclDeptName = emAclDeptName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstShiftTeam();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'mstShiftId',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.mstShiftId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftName',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.mstShiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'admDeptId',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.admDeptId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.sith.mst.sithMesMstShiftTeam.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    mstShiftIdFilter : "",
    nameFilter : "",
    codeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstShiftIdFilter',
        label: 'label.sith.mst.sithMesMstShiftTeam.filter.mstShiftId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesMstShift'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeam.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.sith.mst.sithMesMstShiftTeam.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeam.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.sith.mst.sithMesMstShiftTeam.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstShiftId',
        label: 'label.sith.mst.sithMesMstShiftTeam.entity.mstShiftId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'sithMesMstShift'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShiftTeam.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstShiftTeam.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emAclDeptName',
        label: 'label.sith.mst.sithMesMstShiftTeam.entity.emAclDeptName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"admDeptId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShiftTeam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstShiftTeam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
